import type { ComponentContentSchema, SlotGroupDefinition } from '@vibesites/runtime';
import { EditableSlotGroup, RichTextContent } from '@vibesites/runtime/react';
import {
  INNER_PAGE_HERO_TITLE_CLASS,
  InnerPageHeroSection,
} from './shared/InnerPageHeroSection';

const bgImageDef: SlotGroupDefinition = {
  label: 'Background Image',
  fields: {
    image: {
      label: 'Image',
      type: 'image',
      defaultField: 'property_featured_image',
    },
    alt: {
      label: 'Alt Text',
      type: 'text',
      defaultValue: 'Thank you banner',
    },
  },
};


export function ThankYouHero() {
  return (
    <InnerPageHeroSection
      bgGroupPath="thankyouhero.bg_image"
      bgImageDef={bgImageDef}
      altFallback="Thank you banner"
    >
      <RichTextContent
        path="thankyouhero.title"
        as="h1"
        className={INNER_PAGE_HERO_TITLE_CLASS}
      />
      <EditableSlotGroup
        groupPath="thankyouhero.bg_image"
        definition={bgImageDef}
        className="hidden"
        style={{ display: 'none' }}
      >
        <span />
      </EditableSlotGroup>
    </InnerPageHeroSection>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'ThankYouHero',
  displayName: 'Thank You Hero',
  tokens: {
    'thankyouhero.title': {
      label: 'Title',
      type: 'richtext',
      defaultValue: '<p>Thank You</p>',
    },
  },
  slotGroups: {
    'thankyouhero.bg_image': bgImageDef,
  },
};

(ThankYouHero as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default ThankYouHero;
